// Icon mục "Danh mục thuốc đang bán": sổ danh mục có dấu tick, vẽ bằng currentColor để đổi màu khi active
export default function CatalogMenuIcon({ size = 24, color = 'currentColor', className }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
      <rect x="4" y="3" width="16" height="18" rx="2.5" />
      <path d="M9 3v2.5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V3" />
      <path d="M8.5 11.5h7" />
      <path d="M8.5 15h4" />
      <path d="m14.5 14.6 1.2 1.2 2.3-2.4" />
    </svg>
  );
}
